import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const FraudBlacklistAndWhitelistRBAC = {
  pageID: 'd93401cd1da8476286b14f78eba80bb5',
  elementID: {
    View: 'f6dfa3201f8c421eea117f277137fe06',
    addBlacklist: '97e5c967f2f2ba29d82287d4b31f09e3',
    addWhitelist: '421f368561f2b9eff952b9c872305015',
    togleWhitelist: '2590ef01acf3650573fa9ee37ef8b1b4',
    togleBlacklist: 'cd423239a3f36549d4985089a5e3ae52',
  },
} as const

export const useFraudBlacklistAndWhitelistRBACPage = createUseRBAC(
  FraudBlacklistAndWhitelistRBAC.elementID,
)

export type UseFraudBlacklistAndWhitelistRBACPageType = ReturnType<
  typeof useFraudBlacklistAndWhitelistRBACPage
>
